import { combineReducers } from 'redux';

import businessAdmin from './businessAdmin';

export default combineReducers({
  businessAdmin,
});
